/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetBlogPostsByIdsDto } from '../../models/get-blog-posts-by-ids-dto';
import { PaginatedDtoOfBlogPostListItemDto } from '../../models/paginated-dto-of-blog-post-list-item-dto';

export interface GetPostsByIds$Params {
      body: GetBlogPostsByIdsDto
}

export function getPostsByIds(http: HttpClient, rootUrl: string, params: GetPostsByIds$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfBlogPostListItemDto>> {
  const rb = new RequestBuilder(rootUrl, getPostsByIds.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfBlogPostListItemDto>;
    })
  );
}

getPostsByIds.PATH = '/api/v1/blog/posts/by-ids';
